import React, { useState } from 'react';

const BufferedVideo = () => {
  const [isBuffering, setIsBuffering] = useState(false);

  return (
    <div className="">
      {isBuffering && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white px-4 py-2 rounded shadow z-10">
          Buffering...
        </div>
      )}

      <video
        preload="auto"
        autoPlay
        muted
        loop
        playsInline
        poster="/images/banner.jpg"
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        onWaiting={() => setIsBuffering(true)}
        onPlaying={() => setIsBuffering(false)}
      >
        <source src="/videos/yamaha-promo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default BufferedVideo;
